import React, { ReactNode, useContext, useState } from "react";
import { Button, Grid } from "@material-ui/core";

import translate from "../i18n/Translator";
import DialogPopup from "../components/DialogPopup";
import { updatePayment } from "../api/PaymentAPI";
import { AppContext } from "../context/AppContext";
import { Payment, PaymentConciliateRequest } from "../model/Payment";
import { ErrorSnackbar } from "../components/Snackbars";

export interface DefaultCompletePaymentPopupProps {
    paymentId: string;
    onClose(): any;
    onSuccess(payment: Payment): any;
}

interface CompletePaymentPopupProps extends DefaultCompletePaymentPopupProps {
    approved: boolean;
    title: ReactNode;
    content: ReactNode;
    button: "secondary" | "primary";
}

export default function CompletePaymentPopup(props: CompletePaymentPopupProps) {
    const context = useContext(AppContext);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string>();

    const update = () => {
        setSubmitting(true);
        const request = {
            approved: props.approved
        } as PaymentConciliateRequest;

        updatePayment(context.session!.tenant!.id, props.paymentId, request).then(response => {
            props.onSuccess(response);
        }).catch(error => {
            setSubmitting(false);
            setError(error.message);
        });
    };

    return (
        <DialogPopup open title={props.title} onClose={props.onClose}
            disable={submitting}
            disableBackdropClick={submitting}
            disableEscapeKeyDown={submitting}
            closeColor="default"
            closeText={translate("buttons.cancel") as string}
            button={(
                <Button onClick={update} variant="outlined" color={props.button} disabled={submitting}>
                    {translate("buttons.confirm")}
                </Button>
            )}>
            <Grid container justify="space-between" alignItems="center">
                <Grid item xs={12}>
                    {props.content}
                </Grid>
            </Grid>
            <ErrorSnackbar message={error} onClose={() => setError(undefined)} />
        </DialogPopup>
    );
}